import styled, { css } from 'styled-components';
import { StyledTableBodyCell } from '../TableCell/TableBodyCell/styled.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var TableRow = styled.tr.withConfig({
  displayName: "TableRow",
  componentId: "sc-1cp9zk2-0"
})(["height:", ";", "{", ";border-top:", " solid transparent;border-bottom:", " solid transparent;border-color:", ";&:first-child{border-left:", " solid transparent;border-left-color:", ";border-top-left-radius:", ";border-bottom-left-radius:", ";}&:last-child{border-right:", " solid transparent;border-right-color:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";}", ";}&:not([disabled])&:hover ", "{border-color:", ";", ";}"], themeGet('spacing.6xl'), StyledTableBodyCell, function (props) {
  return props.disabled && "opacity: 0.5;";
}, pxToRem(1), pxToRem(1), function (props) {
  return props.$expanded ? themeGet('colors.border.200') : 'transparent';
}, pxToRem(1), function (props) {
  return props.$expanded ? themeGet('colors.border.200') : 'transparent';
}, themeGet('borderRadius.md'), function (props) {
  return props.$expanded ? 0 : themeGet('borderRadius.md');
}, pxToRem(1), function (props) {
  return props.$expanded ? themeGet('colors.border.200') : 'transparent';
}, themeGet('borderRadius.md'), function (props) {
  return props.$expanded ? 0 : themeGet('borderRadius.md');
}, function (props) {
  return props.$expanded && css(["border-bottom-color:transparent;"]);
}, StyledTableBodyCell, themeGet('colors.border.200'), function (props) {
  return props.$expanded && css(["border-bottom-color:transparent;"]);
});

export { TableRow };
